// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"5ee15053","660":"5627a246","774":"ac2ac9b8","820":"ce8e5881","851":"cfb43ce6","883":"14706701"}[chunkId] + ".chunk.js";
};